import min from 'lodash/min'
const Resizer = {
   install(vue) {
      vue._lastHeight = 0;
      vue.resize_frame = function (delay) {
         const root = document.getElementById('apikit-app');
         if (!BX24 || !root) return;

         setTimeout(function() {
            const currentSize = BX24.getScrollSize();
            const height = min([currentSize.scrollHeight < 800
               ? 800
               : currentSize.scrollHeight, root.offsetHeight]) + 20;

            if (height !== vue._lastHeight) {
               vue._lastHeight = height;
               BX24.resizeWindow(root.offsetWidth, height);
            }
         }, delay || 0);
      };

      vue.mixin({
         methods: {
            resize_frame: vue.resize_frame
         }
      })
   }
};


export {
   Resizer,
};
